/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum BellMessageTypes {
    Permanent = 'permanent',
    AsyncAction = 'asyncAction',
}
